import { render, staticRenderFns } from "./ImportCustomersForm.vue?vue&type=template&id=4063956e&"
import script from "./ImportCustomersForm.vue?vue&type=script&lang=js&"
export * from "./ImportCustomersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports